// productSlug.js
//
// Generates human-readable, non-revealing product URLs by combining a
// name-derived slug with a URL-safe base64 encoded Firestore ID.
//
// Format: /product/{name-slug}--{base64url-encoded-id}
// Example: /product/pink-roses--NTUwRTg0MDA
//
// The encoded suffix is fully reversible — no extra DB lookups needed.
// The Swift equivalent lives in BusinessStack/SharedFiles/EcommerceProduct.swift.

const nameToSlug = (name) =>
  name.toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '-');

const encodeId = (id) =>
  btoa(id).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');

const decodeId = (encoded) =>
  atob(encoded.replace(/-/g, '+').replace(/_/g, '/'));

// Builds the full /product/... path for a product object.
export const buildProductPath = (product) => {
  const slug = nameToSlug(product.productName || '');
  const encoded = encodeId(product.id);
  return `/product/${slug}--${encoded}`;
};

// Extracts the Firestore ID from a :slug route param.
// Falls back to treating the param as a raw ID for backwards compatibility.
export const parseProductSlug = (param) => {
  const parts = param.split('--');
  if (parts.length < 2) return param;
  try { return decodeId(parts[parts.length - 1]); }
  catch { return param; }
};
